<template>
    <div class="message-attach-list" :class="{'attachments-thumbs' : thumbnails}">
        <div class="attach-header">
            <i class="fas fa-paperclip"></i>
            <small>{{attachments.count}} {{Language.say(attachments.count > 1 ? "messages.open.attachments.multiple" : "messages.open.attachments.one" )}}</small>
            <LinkButton v-if="attachments.download"
                :link="attachments.download"
                icon='fas fa-download'
                class='clear'
                :text="'messages.open.attachments.download_all'"
            />
        </div>
        <div ref="attachments_container" class="attachments" :class="{'collapsed' : expanded}">
            <div v-for="attachment,index in props.attachments.items" :ref="setElement" :key="index" class="attach-item" :class="'type-' + attachment.type" aria-label="Anexo" tabindex="0">
                <div
                     @click="onAttachmentClick(index)"
                     v-tooltip='"messages.open.attachments.preview"'
                     class='button clear'
                     tabindex="0"
                >
                    <img v-if="thumbnails && attachment.type === 'image'" :src="attachment.thumbnail_url">
                    <span>{{attachment.name}}<small>{{attachment.size}}</small></span>
                </div>
                <LinkButton v-if='attachment.download'
                    :link="attachment.download_url || attachment.contents || attachment.download"
                    :download="attachment.name"
                    v-tooltip='"messages.open.attachments.download"'
                    icon='fas fa-download'
                    class='clear'
                />
            </div>

            <span v-if="hidden_count > 0 || expanded === true"
              @click="onExpandToggle()"
              role="button"
              class="button clear show-more"
            >
                <small class="counter">
                  {{hidden_count}}
                </small>
                <i class="fas"
                  :class="{'fa-chevron-down' : !expanded, 'fa-chevron-up': expanded }">
                </i>
            </span>

        </div>
    </div>
</template>

<script setup>
  import {defineProps, defineEmits, ref, onMounted} from 'vue';
  import ActionButton                               from '@/vue/Elements/Buttons/ActionButton.vue';
  import LinkButton                                 from '@/vue/Elements/Buttons/LinkButton.vue';
  import Language                                   from '@/js/Shared/Language/Language.js';

  const elements              = ref([]);
  const attachments_container = ref();
  const expanded              = ref(false);
  const hidden_count          = ref(0);
  const hidden_setup          = ref(false);

  const props    = defineProps({
    attachments : {
      required : true,
    },
    thumbnails: {
      default : false,
    },
  })

  const emit = defineEmits([
    'attachmentClick', 'attachmentCloudAdd'
  ]);

  onMounted(() => {
    setObserver();
  })

  const onAttachmentClick = (attachment_id) => {
    emit('attachmentClick', attachment_id, false);
  }

  const onExpandToggle = () => {
    expanded.value = !expanded.value;
  }

  const onCloudAdd = (attachment) => {
    emit('attachmentCloudAdd', attachment);
  }

  const setObserver = () => {
    let observer = new IntersectionObserver(intersectWatcher, {
      root : attachments_container.value,
    });

    elements.value.forEach((element) => {
      observer.observe(element);
    })
  }

  const setElement = (e) => {
    elements.value.push(e);
  }

  const intersectWatcher = (e) => {
    if (hidden_setup.value === false) {
      intersectSetup(e);
      return;
    }

    intersectChanges(e);
  }

  const intersectSetup = (e) => {
    e.forEach((element) => {
      if (!element.isIntersecting) {
        hidden_count.value++;
      }
    })

    hidden_setup.value = true;
  }

  const intersectChanges = (e) => {
    e.forEach((element) => {
      if (!element.isIntersecting) {
        hidden_count.value++;
        return;
      }
      hidden_count.value--;
    })
  }
</script>
